"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWithdrawsResponseAllOfToJSON = exports.GetWithdrawsResponseAllOfFromJSONTyped = exports.GetWithdrawsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetWithdrawsResponseAllOfFromJSON(json) {
    return GetWithdrawsResponseAllOfFromJSONTyped(json, false);
}
exports.GetWithdrawsResponseAllOfFromJSON = GetWithdrawsResponseAllOfFromJSON;
function GetWithdrawsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'withdraws': (json['withdraws'].map(_1.WithdrawFromJSON)),
    };
}
exports.GetWithdrawsResponseAllOfFromJSONTyped = GetWithdrawsResponseAllOfFromJSONTyped;
function GetWithdrawsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'withdraws': (value.withdraws.map(_1.WithdrawToJSON)),
    };
}
exports.GetWithdrawsResponseAllOfToJSON = GetWithdrawsResponseAllOfToJSON;
